/* Blocks – bundler */
import './cards.js';
import './faq.js';
import './logos.js';
import './maps.js';

export function mount() {
  // Momenteel zijn de blokken zelf-executing modules.
  // Als je mountable functies wilt, kun je die exporteren en hier aanroepen.
}
